<script setup>
import {ref, watch} from "vue";

const emit = defineEmits(['step', 'change']);
const {privacyLink, conditionsLink, value, loading} = defineProps(['privacyLink', 'conditionsLink', 'value', 'loading']);

const accepted_gdpr = ref( value.gdpr );
const accepted_gcs = ref( value.gcs );
const is_loading = ref( loading );

watch( [accepted_gdpr, accepted_gcs], () => {
    emit('change', {
        gdpr: accepted_gdpr,
        gcs: accepted_gcs,
    } );
} );

watch( () => loading, value => is_loading.value = value );
</script>

<template>
    <div class="flex flex-col">
        <div class="flex flex-col lg:flex-row mb-10">
            <div class="mb-10 lg:mb-0">
                <button type="button" @click="emit('step', 'previous')" title="Retour" aria-label="Retour"
                        class="button-invert | px-5 py-2">
                    <i class="fa-solid fa-angle-left | mr-2"></i> Retour
                </button>
            </div>

            <h2 class="text-white text-4xl text-center lg:w-10/12">Confirmation de votre inscription</h2>
        </div>

        <div class="flex flex-col lg:flex-row gap-x-10">
            <div class="flex flex-col w-full lg:w-2/3 mx-auto p-10 rounded-3xl mb-10">
                <div class="mb-5">
                    <input type="checkbox" id="input_gcs" class="relative top-1 w-5 h-5 mr-2 cursor-pointer" v-model="accepted_gcs">
                    <label for="input_gcs" class="text-white mr-2 cursor-pointer">Je confirme avoir lu et accepté <a
                        :href="conditionsLink" class="link" target="_blank">les conditions générales de vente</a>.</label>
                </div>

                <div class="mb-5">
                    <input type="checkbox" id="input_gdpr" class="relative top-1 w-5 h-5 mr-2 cursor-pointer" v-model="accepted_gdpr">
                    <label for="input_gdpr" class="text-white mr-2 cursor-pointer">Je confirme avoir lu et accepté <a
                        :href="privacyLink" class="link" target="_blank">la politique de confidentialité</a>.</label>
                </div>
            </div>

            <div class="w-full lg:w-1/3 mb-10">
                <slot></slot>
            </div>
        </div>

        <div class="text-center">
            <button class="button | px-5 py-3" type="button" :disabled="!accepted_gcs || !accepted_gdpr || loading" @click="emit('step', 'submit');">
                <span v-if="!loading">Confirmer <i class="fa-solid fa-check | ml-2"></i></span>
                <i v-if="loading" class="fa-solid fa-spinner fa-spin"></i>
            </button>
        </div>
    </div>
</template>